/**
 * "Como está seu coração hoje?" — o `mood_picker.dart` com o `heart_emoji.dart`
 * dentro.
 *
 * Faltava inteiro: desde a migração o painel do site sabia **ler** o humor de
 * cada um e não sabia **perguntar**, então quem entrava aqui via "ainda não
 * disse" ao lado do próprio nome sem ter como dizer. Escrever humor só era
 * possível no relógio.
 *
 * O que o navegador obrigou a mudar:
 *
 * - **Quem decide se a pergunta aparece.** Lá é o `GuardianController`, que o
 *   `dashboard_screen` manda mostrar no `initState` e o próprio picker manda
 *   esconder depois de gravar. Aqui o painel já tem em mãos o humor mais
 *   recente de cada pessoa, então a pergunta simplesmente não é desenhada
 *   quando o de hoje já está gravado — mesmo resultado, sem controlador.
 * - **Não há emoji "escolhido".** O `isSelected` do `HeartEmoji` só faz sentido
 *   enquanto o picker continua na tela depois da escolha; aqui ele sai no mesmo
 *   instante, porque o humor de hoje passou a existir. O `glowColor` de cada um
 *   não se perdeu: virou o halo do toque e do foco.
 * - **Sem o `SnackBar` do "Mandando carinho para ...".** O site não tem tarja de
 *   recado, e o retorno já está uma linha acima: a linha de quem escolheu troca
 *   de "ainda não disse" para o emoji assim que o armazém grava.
 */

import {
  HUMORES,
  dizerHumor,
  ligacao,
  traduzir,
  usarSessao,
  type Humor,
} from '@nosso-sempre/shared';
import './escolhaDeHumor.css';

export function EscolhaDeHumor() {
  const { armazem } = ligacao();
  const { quem } = usarSessao();

  if (!quem) return null;
  const eu = quem;

  async function escolher(humor: Humor) {
    try {
      await dizerHumor(armazem, eu, humor);
    } catch {
      // Igual ao jardim: um humor que não gravou não vira aviso na cara de
      // ninguém — a pergunta continua na tela, e o próximo toque tenta de novo.
    }
  }

  return (
    <div className="humor-pergunta">
      <p className="humor-pergunta-titulo">{traduzir('Como está seu coração hoje?')}</p>
      <ul className="humor-fila">
        {HUMORES.map((h) => (
          <li key={h.nota}>
            <button
              className="humor-escolha"
              type="button"
              style={{ ['--brilho' as string]: h.brilho }}
              onClick={() => void escolher(h)}
              aria-label={traduzir('Humor {emoji}', { emoji: h.emoji })}
            >
              <span aria-hidden="true">{h.emoji}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
